import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ScrollToTop from './shared/components/ScrollToTop';
import { AuthProvider } from './shared/context/AuthContext';
import { PlatformFeaturesProvider } from './shared/context/PlatformFeaturesContext';
import { ToastProvider } from './shared/ui';
import { AppRoutes } from './app/routes/AppRoutes';
import './shared/ui/ui.css';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <PlatformFeaturesProvider>
        <ToastProvider>
          <Router>
            <ScrollToTop />
            <AppRoutes />
          </Router>
        </ToastProvider>
      </PlatformFeaturesProvider>
    </AuthProvider>
  );
}

export default App;
